import type { LinkGroups } from "@/pages/clientWidgets/types";
import { Link } from "./links/Link.tsx";

type Props = {
	links?: LinkGroups;
};

export function Links({ links }: Props): React.ReactNode | null {
	const { left, right } = links ?? {};

	if (!right?.path || !right?.title) {
		return null;
	}

	// Rule is a false-positive, a href attribute is set within Link
	const rightLink = <Link path={right.path} title={right.title} />;

	if (!left?.path || !left?.title) {
		return rightLink;
	}

	return (
		<>
			<div style={{ float: "left" }}>
				{/* Rule is a false-positive, a href attribute is set within Link */}
				<Link path={left.path} title={left.title} />
			</div>
			{rightLink}
		</>
	);
}
